import { createContext, useContext, useState, useCallback } from 'react';

const HelpCtx = createContext(null);

export function HelpProvider({ children }) {
  const [content, setContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const register = useCallback((c) => setContent(c), []);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <HelpCtx.Provider value={{ content, isOpen, register, open, close }}>
      {children}
    </HelpCtx.Provider>
  );
}

const NOOP_CTX = { content: null, isOpen: false, register: () => {}, open: () => {}, close: () => {} };

export function useHelpContext() {
  return useContext(HelpCtx) ?? NOOP_CTX;
}
